import React, {useEffect, useContext} from 'react';
import {ViewDataContext} from '../../commons/context/view/ViewDataContext';
import RTSDataUI from "./RTSDataUI";
import {FiltersStateContext} from "../../commons/context/FiltersStateContext";
import {getRefreshInterval, isINRegion} from "../../util/CommonUtils";
import {useDeviceLayout} from "../../commons/context/DeviceLayoutContext";

export const RTSData = () => {

    let search = window.location.search;
    let params = new URLSearchParams(search);
    let stationCode = params.get('stationCode');

    const {viewModel, dispatch} = useContext(ViewDataContext)
    //Whenever filter value will change, it should re render
    const {selectedFilterValues} = useContext(FiltersStateContext)
    const {spacingInset_shorthand2} = useDeviceLayout();
    useEffect(() => {

        constructState(selectedFilterValues);
        dispatch({ type: 'LOAD_VIEW', data:{filters: selectedFilterValues , stationCode, view : "RTS_VIEW" ,dispatcher: dispatch, leg:"REVERSE", isCPTFilter: false}});
        const interval = setInterval(() => {

            constructState(selectedFilterValues);
                        //check for inactive tabs
                        if ( !document.hidden)   
                        {     
                            dispatch({ type: 'LOAD_VIEW', data:{filters: selectedFilterValues , stationCode, view : "RTS_VIEW" ,dispatcher: dispatch, leg:"REVERSE", isCPTFilter: false}});
                        }
    }, getRefreshInterval());
    return () => clearInterval(interval);}, isINRegion() ? [selectedFilterValues.startPDD, selectedFilterValues.endPDD, selectedFilterValues.packageTypes_Reverse, selectedFilterValues.shipDateStart, selectedFilterValues.shipDateEnd] : [selectedFilterValues.startPDD, selectedFilterValues.endPDD, selectedFilterValues.packageTypes_Reverse]);

    return (
        <RTSDataUI data = {viewModel.metricResult} isLoading = {viewModel.isLoading} isRtsAgeingGenericLabelsEnabled = {viewModel.rtsAgeingGenericLabelsEnabled}
             appliedFilterURL = { selectedFilterValues.appliedFilterURL} spacingInset_shorthand2={spacingInset_shorthand2}/>
    )

}

const constructState = (selectedFilterValues) => {
    var values = {

        startPDD : selectedFilterValues.startPDD,
        endPDD : selectedFilterValues.endPDD,
        packageTypes_Reverse : selectedFilterValues.packageTypes_Reverse

    }

    //Redirect to search path
    var path = window.location.href.split("rtsBoard")[0];
    return window.location.replace( path + "rtsBoard/"+ JSON.stringify(values).replace('/','%2f'));
}


// WEBPACK FOOTER //
// ./src/components/rts/RTSData.js